// import React, { useContext } from "react";
// import { LanguageContext } from "../context/LanguageContext";
// import en from "../data/data.json";
// import cs from "../data/data_cs.json";


// export const Services = (props) => {
//   const { language } = useContext(LanguageContext);
//   const translations = language === 'cs' ? cs : en;

//   return (
//     <div id="services" className="text-center">
//       <div className="container">
//         <div className="section-title">
//           <h2>Our Services</h2>
//           <p>
//             Lorem ipsum dolor sit amet, consectetur adipiscing elit duis sed
//             dapibus leonec.
//           </p>
//         </div>
//         <div className="row">
//           {props.data
//             ? props.data.map((d, i) => (
//                 <div key={`${d.name}-${i}`} className="col-md-4">
//                   {" "}
//                   <i className={d.icon}></i>
//                   <div className="service-desc">
//                     <h3>{d.name}</h3>
//                     <p>{d.text}</p>
//                   </div>
//                 </div>
//               ))
//             : "loading"}
//         </div>
//       </div>
//     </div>
//   );
// };


import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import en from "../data/data.json";
import cs from "../data/data_cs.json";
import ReactMarkdown from 'react-markdown';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export const Services = () => {
  const { language } = useContext(LanguageContext);
  const translations = language === 'cs' ? cs : en;

  // prices now come from translations.Services[].price (no regex parsing)

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{translations.ServicesTitle || "Our Services"}</h2>
        </div>
        <div className="row">
          {translations.Services
            ? translations.Services.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    {
                      d.markdown ? (
                        <ReactMarkdown>{d.markdown}</ReactMarkdown>
                      ) : Array.isArray(d.text) ? (
                        d.text.map((p,i)=><p key={i}>{p}</p>)
                      ) : d.text ? (
                        <Markdown source={d.text} />
                      ) : null
                    }
                    {d.price && (
                      <div className="price-wrap">
                        <span className="price-highlight">{d.price}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};

function Markdown({ source }) {
  const html = React.useMemo(() => {
    return DOMPurify.sanitize(marked.parse(source || ''));
  }, [source]);
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}